import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment";
import CustomerService from "services/CustomerService";

export const getAllCustomerApi = createAsyncThunk(
  "customer/getAllCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CustomerService.getAllCustomer(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getCustomerById = createAsyncThunk(
  "customer/getCustomerById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await CustomerService.getCustomerById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getCustomerSummary = createAsyncThunk(
  "customer/getCustomerSummary",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CustomerService.getCustomerSummary();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportExcelCustomerApi = createAsyncThunk(
  "customer/export-excel",
  async (data, { rejectWithValue }) => {
    try {
      const blob = await CustomerService.exportExcel(data);
      const url = window.URL.createObjectURL(blob);

      const exportTime = moment().format("DDMMYYYY_HHmmss");
      const filename = `Danh_sach_khach_hang_${exportTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportExcelCustomerHistoryApi = createAsyncThunk(
  "customer/export-excel-history",
  async (data, { rejectWithValue }) => {
    try {
      const blob = await CustomerService.exportExcelHistory(data);
      const url = window.URL.createObjectURL(blob);

      const exportTime = moment().format("DDMMYYYY_HHmmss");
      const filename = `Lịch sử đơn hàng ${exportTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  customerList: [],
  customerDetail: {},
  customerSummary: {},
};
export const storeCustomerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setCustomer: (state, action) => {
      state.customerList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCustomerApi.fulfilled, (state, action) => {
        state.loading = false;
        state.customerList = action.payload;
      })
      .addCase(getAllCustomerApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getCustomerById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerById.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDetail = action.payload;
      })
      .addCase(getCustomerById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getCustomerSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.customerSummary = action.payload;
      })
      .addCase(getCustomerSummary.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(exportExcelCustomerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(exportExcelCustomerApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(exportExcelCustomerApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(exportExcelCustomerHistoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(exportExcelCustomerHistoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(exportExcelCustomerHistoryApi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setCustomer } = storeCustomerSlice.actions;

export default storeCustomerSlice.reducer;
